(ns io.daskul.webapp.panel.subs
  "Generic panel state subscriptions for slide-over panels."
  (:require
   [re-frame.core :as rf]))

(rf/reg-sub
 ::panel-open?
 (fn [db _]
   (get-in db [:ui :panel :open?] false)))

(rf/reg-sub
 ::panel-mode
 (fn [db _]
   (get-in db [:ui :panel :mode])))

(rf/reg-sub
 ::panel-entity-id
 (fn [db _]
   (get-in db [:ui :panel :entity-id])))
